module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.97fc5e1.eot";